module.exports = __webpack_public_path__ + "static/media/bowen-11.7aa2b32a.jpg";